import type { ReactElement } from 'react';
import { useEntity } from 'components';
import type { Enterprise } from 'modules/core/types';
import { LazyRadioSurveys } from 'modules/balticRadioSurvey/lazy';

export function RadioSurveys(): ReactElement {
  const { item } = useEntity<Enterprise>();
  return <LazyRadioSurveys key={item.id} agencyId={item.id} />;
}
